<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="addeway"
      body-class="bg-white"
      cancel-variant="light"
      title="Add e-Way Bill Details"
      ref="addeway"
      @ok.prevent="onSubmit()"
      :ok-disabled="submitted"
      :ok-title-html="submitted==true?loaderIcon+'Save':'Save' "
      @shown="field.eway_bill_no=eway_bill_no!=''?eway_bill_no:''"
    >
      <b-form-group>
        <b-row>
          <b-col>
            <b-form-group
              horizontal
              :label="'e-Way Bill Number'"
              label-class="required"
              :label-cols="4"
              label-breakpoint="md"
              label-for="eway_bill_no"
            >
              <input
                v-model.trim="field.eway_bill_no"
                name="e-Way Bill Number"
                :class="{ 'form-control': true}"
                type="text"
                id="e-Way Bill Number"
                v-validate="'max:15|numeric'"
              />
            </b-form-group>
            <span
              class="fw-semi-bold text-danger"
              v-if="errors.has('e-Way Bill Number')&&error_show"
            >{{ errors.first('e-Way Bill Number') }}</span>
          </b-col>
        </b-row>
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: ["id", "eway_bill_no", "module_name"],
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      error_show: false,
      field: {
        eway_bill_no: ""
      }
    };
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitted = true;
          let data = JSON.stringify({
            id: this.id,
            eway_bill_no: this.field.eway_bill_no
          });
          this.$store
            .dispatch(this.module_name + "/ewaybill", data)
            .then(response => {
              this.submitted = false;
              if (response.data.type == "success") {
                this.$refs.addeway.hide();
                this.$emit("setewaybillno");
              }
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: response.data.status,
                type: response.data.type,
                showCloseButton: true
              });
            });
        } else {
          this.error_show = true;
        }
      });
    }
  }
};
</script>